import React, { Component } from "react";
import { Modal } from "react-bootstrap";

export default class CopyrightPolicy extends Component {
  render() {
    const { show, closeModal } = this.props;
    return (
      <React.Fragment>
        <Modal
          show={show}
          dialogClassName="banner-modal copyright-modal"
          onHide={closeModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>Copyright Policy</Modal.Title>
          </Modal.Header>
          <Modal.Body className="copyright-policy">
            Material featured on the "Project Monitoring Group" (PMG) web portal
            may be reproduced free of charge after taking proper permission by
            sending a mail to us. However, the material has to be reproduced
            accurately and not to be used in a derogatory manner or in a
            misleading context. Wherever the material is being published or
            issued to others, the source must be prominently acknowledged.
            However, the permission to reproduce this material shall not extend
            to any material which is identified as being copyright of a third
            party. Authorisation to reproduce such material must be obtained
            from the departments/copyright holders concerned.
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}
